import { Component, Input, AfterViewInit } from '@angular/core';
import { SpecialsItem } from '../../menu.model';

@Component({
  selector: 'bites',
  templateUrl: './bites.component.html',
  styleUrls: ['./bites.component.scss']
})
export class BitesComponent implements AfterViewInit {

  @Input() specials: Array<SpecialsItem> = [];

  @Input() darkMode: string = '';

  @Input() activeSection: string | undefined;

  constructor() { }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

}
